<template>
<v-container fluid class="pa-5 secondary">
    
     <v-card solo elevation="5" class="pa-5 primary">
       <h1 class="d-flex justify-center textTitle--text font-weight-black">{{ $t('addpreciocompramayor.sellScreenTitle') }}</h1>
           <div>
              <v-data-table
                :headers="headerspreciomayor"
                :items="preciosventasmayor"
                class="elevation-5 tertiary pa-3 ma-5 textTable--text font-weight-black text-h3"
              >
                <template v-slot:[`item.pu`]="props">
                    <v-row class="align-center justify-center"><v-icon class="mx-2" @click="minusPu(props.item)">mdi-minus</v-icon>
            <div width="30px"><v-text-field min=0  class="font-weight-black shrink" type="number" v-model.number="props.item.pu"></v-text-field></div>
            <v-icon class="mx-2" @click="masPu(props.item)">mdi-plus</v-icon></v-row>
                  
                </template>
                <template v-slot:[`item.supprimir`]="{ item }">
                  <v-btn small rounded class="error" @click="deletePrecioSellMayor(item.id)">X</v-btn>
                
                </template>

                <template v-slot:[`item.qty`]="props">
                
                  <v-row class="justify-center">
                      
                      <v-icon small class="mx-2" @click="minusQty(props.item)">mdi-minus</v-icon>
            <v-text-field min=0  class="font-weight-black shrink" type="number" v-model.number="props.item.qty"></v-text-field>
            <v-icon small class="mx-2" @click="masQty(props.item)">mdi-plus</v-icon>
                          </v-row>
                  
                  
                </template>
              </v-data-table>
              <v-row class="justify-center align-end">
                  <v-col cols="6">
                      <h3 class="textTitle--text font-weight-black text-center">{{ $t('addpreciocompramayor.pu') }}</h3>
                        <v-text-field type="number" v-model.number="pu_sellmayor" prefix="Q." background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
                                  
                  </v-col>
                  <v-col cols="6">
                      <h3 class="textTitle--text font-weight-black text-center">{{ $t('addpreciocompramayor.qtyNeed') }}</h3>
                      
                      <v-text-field v-model.number="qtyformayorsell" type="number" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink" ></v-text-field>
                                  
                  </v-col>
                  
                                 
                                  
                              </v-row>
                              <v-row class="justify-center">
                                  <v-btn @click="addPrecioSellMayor" class="ma-4 pa-2 font-weight-black black--text" color="success">{{ $t('addpreciocompramayor.addButton') }}</v-btn>
                              </v-row>

            </div>
         </v-card>
</v-container>
</template>

<script>
  import {mapGetters} from 'vuex'

export default {
    components:{},
      props:['preciosventasmayor'],
    data () {
      return {

            qtyformayorsell:0,
            
            pu_sellmayor:0,
            

      }
    },
      computed:{
      headerspreciomayor(){
         var headerspreciomayor= [
              { text: this.$i18n.t('headers.unitPrice'),align: 'start',value: 'pu',class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center'},
              { text: this.$i18n.t('headers.qtyNeed'), value: 'qty',class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center' },
              { text: this.$t('delete'), value:'supprimir', class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center'}
              ]
              return headerspreciomayor},
      ...mapGetters({
        
        fournisseursDb:'fournDb'
      })
    },
    methods: {
        masPu(price){
         
        price.pu+=1
      },
      minusPu(price){
        if(price.pu>0){
        price.pu-=1}
      },
        masQty(price){
         
        price.qty+=1
      },
      minusQty(price){
        if(price.qty>0){
        price.qty-=1}
      },
        
        addPrecioSellMayor(){
        var preciosmayorsell = this.preciosventasmayor;
        var id='pu_mayorsell1';
        var size = preciosmayorsell.length
        
        if(size!=0){
            var pos=1

            for(var i=0;i<size;i++){
              if(preciosmayorsell[i].id!=id){continue}else{
                pos+=1
                id='pu_mayorsell'+pos
                i=0
              }
            }
            
            }
        const newpreciosmayor = [...(preciosmayorsell || []), {id:id,pu:this.pu_sellmayor,qty:this.qtyformayorsell}];
        this.$emit('update',newpreciosmayor)
      },
      deletePrecioSellMayor(id){
        var preciosmayorsell = this.preciosventasmayor
        var temparray=[];
          if(id!=null){
            var size = preciosmayorsell.length; 
            for(var i=0;i<size;i++){
              if(preciosmayorsell[i].id!=id){
                    temparray.push(preciosmayorsell[i])
              }                  
            }
            this.$emit('update',temparray)
            
          }
      },
    },
  }
</script>